import { countries, Language } from "./Config";
// import moment from "moment";
import moment from 'moment-timezone';



let MODE = "development"
let BASE_URL = process.env.REACT_APP_BASE_URL


let helper = {
    ApiUrl: BASE_URL + '/api/supplier/',
    validExtensions: ['jpg', 'png', 'jpeg', 'svg'],
    baseUrl: BASE_URL,
    S3Url: process.env.REACT_APP_AWS_URL,
    productImageDir: process.env.REACT_APP_S3_PRODUCT_IMAGE_DIRECTORY,
    profileImageDir: process.env.REACT_APP_S3_PROFILE_IMAGE_DIRECTORY,
    companyImageDir: process.env.REACT_APP_S3_COMPANY_IMAGE_DIRECTORY,
    footerImageDir: process.env.REACT_APP_S3_FOOTER_IMAGE_DIRECTORY,
    mapboxAccessToken: process.env.REACT_APP_MAP_BOX_ACCESSTOKEN,
    payoutReceiptDirectory: process.env.REACT_APP_S3_PAYOUT_RECEIPT_DIRECTORY,
    bookingReceiptDirectory: process.env.REACT_APP_S3_BOOKING_RECEIPT_DIRECTORY,
    touristUrl: process.env.REACT_APP_TOURIST_URL,
    adminWhatsappNumber: process.env.REACT_APP_ADMIN_WHATSAPP_NUMBER,
    stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
}

export const phoneErrorMap = [
    "Invalid phone number",
    "Invalid country code",
    "Phone numbr is Too short",
    "Phone numbr is Too long",
    "Invalid phone number"
];

export const roles = {
    1: 'Super Admin',
    2: 'Admin',
    3: 'Admin Moderator',
    4: 'Supplier Admin',
    5: 'Supplier Moderator',
    6: 'User',
};

export function ApiHeaders(token) {
    let apiHeader = {};
    if (token != null) {
        apiHeader['Authorization'] = `Bearer ${token}`
    }
    apiHeader['Access-Control-Allow-Origin'] = '*'
    // apiHeader['Content-Type'] = 'application/json'
    apiHeader['Accept'] = 'application/json'


    return apiHeader;
}

export function formatMbWayNumber(dialCode, mobileNumber) {
    // Remove the '+' from the mobile number
    let cleanedNumber = mobileNumber.replace(/^\+/, '');

    // Remove the dial code if it exists at the start of the number
    if (cleanedNumber.startsWith(dialCode)) {
        cleanedNumber = cleanedNumber.slice(dialCode.length);
    }

    return `${dialCode}#${cleanedNumber}`;
}

function convertHoursToDaysAndHours(hours) {
    var days = Math.floor(hours / 24);
    var remainingHours = hours % 24;

    var result = '';
    if (days > 0) {
        result += days + ' day' + (days > 1 ? 's' : '');
    }
    if (remainingHours > 0) {
        result += (days > 0 ? ' and ' : '') + remainingHours + ' hour' + (remainingHours > 1 ? 's' : '');
    }

    return result;
}

// const calculateCutoffTime = (dateString, timeString, cutoffHours) => {
//     const dateTimeString = `${dateString} ${timeString}`;
//     const dateTime = moment(dateTimeString, "YYYY-MM-DD HH:mm");
//     const updatedDateTime = dateTime.subtract(cutoffHours, 'hours');

//     return updatedDateTime.format("DD MMMM YYYY [at] HH:mm");
// };

const calculateCutoffTime = (dateString, timeString, cutoffHours, timezone = 'UTC') => {
    const dateTimeString = `${dateString} ${timeString}`;

    const dateTime = moment.tz(dateTimeString, 'YYYY-MM-DD HH:mm', timezone);
    const updatedDateTime = dateTime.subtract(cutoffHours, 'hours');

    return updatedDateTime.utc().format('DD MMMM YYYY [at] HH:mm [UTC]');
};

export function generateCancellationPolicy(data) {

    if (typeof data === 'string') {
        data = JSON.parse(data);
    }
    if (!data) {
        return '';
    }

    // data = JSON.parse(data);
    if (data.type) {
        data.policyType = data.type;
    }


    var text = '';
    if (data) {
        if (data.policyType === 'ADVANCED') {
            text = data.title + '\n\n';
            text += 'Cancellation fees are calculated based on a list of penalty rules. Flexible, but complicated.\n';
            data.penaltyRules.forEach(function (rules) {
                var per = rules.percentage;
                text += "• Cancellation fee of " + per + "% is charged if cancelled " + convertHoursToDaysAndHours(rules.cutoffHours) + " or less before the event\n";
            });
        } else if (data.policyType === 'NON_REFUNDABLE') {
            text = data.title + '\n\n';
            text += "Bookings are not refundable, all sales are final.";
        } else if (data.policyType === 'FULL_REFUND') {
            text = data.title + '\n\n';
            text += "Bookings are fully refundable up to the time of the event.";
        } else if (data.policyType === 'SIMPLE') {
            text = data.title + '\n\n';
            text += "Bookings are fully refundable until a specific number of hours before the event.\n";
            text += "• Full refund if cancelled at least " + convertHoursToDaysAndHours(data.simpleCutoffHours) + " before the event";
        } else if (data.policyType == 'hours-before-start') {
            let hours = (data?.cutoff_hours_before) ? data.cutoff_hours_before : 0;
            if (hours == 0) {
                text = "Cancellations are allowed up until the event starts.";
            } else {
                text = `Cancellations are allowed up to ${hours} hour(s) before the event starts.`;
            }
        }
    }

    return text;
}
export function generateCancellationPolicyDateFormat(data, date, time, timeZone) {
    if (typeof data === 'string') {
        data = JSON.parse(data);
    }
    if (!data) {
        return '';
    }

    if (data.type) {
        data.policyType = data.type;
    }



    var text = '';
    if (data) {
        if (data.policyType === 'ADVANCED') {
            // text = "Free Cancellation" + '\n\n';
            // text += 'Cancellation fees are calculated based on a list of penalty rules. Flexible, but complicated.\n';
            var validRules = (data.penaltyRules || []).filter(function (rule) {
                return rule.cutoffHours < 24000;
            });

            validRules.forEach(function (rules) {
                var per = rules.percentage;
                text += "Cancellation fee of " + per + "% is charged after " + calculateCutoffTime(date, time, rules.cutoffHours, timeZone);
            });
        } else if (data.policyType === 'NON_REFUNDABLE') {
            // text = data.title + '\n\n';
            text += "Bookings are not refundable, all sales are final.";
        } else if (data.policyType === 'FULL_REFUND') {
            // text = data.title + '\n\n';
            // text = "Free Cancellation" + '\n\n';
            text += "Free Cancellation Up to " + calculateCutoffTime(date, time, data.simpleCutoffHours, timeZone);
        } else if (data.policyType === 'SIMPLE') {
            // text = data.title + '\n\n';
            // text += "Bookings are fully refundable until a specific number of hours before the event.\n";
            // text += "• Full refund if cancelled at least " + convertHoursToDaysAndHours(data.simpleCutoffHours) + " before the event";
            text += "Fully refundable until " + calculateCutoffTime(date, time, data.simpleCutoffHours, timeZone);

        } else if (data.policyType == 'hours-before-start') {
            let hours = (data?.cutoff_hours_before) ? data.cutoff_hours_before : 0;
            if (hours == 0) {
                text = "Cancellations are allowed up until the event starts.";
            } else {
                text = `Cancellations are allowed up to ${hours} hour(s) before the event starts.`;
            }
        }
    }

    return text;
}
export function convertToTitleCase(string) {
    string = string?.toLowerCase().replace(/_/g, ' ');
    return string?.replace(/\b\w/g, char => char.toUpperCase());
}
export function convertEpochToDate(timestamp) {


    let myDate = new Date(timestamp);
    let dateStr = myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate();
    return dateStr

}
export const imageUrlToBase64 = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        };
        reader.onerror = reject;
    });
};
export async function processImage(imageUrl) {
    try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        // Create a FileReader to convert the Blob to a Data URL
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                const base64Image = reader.result;
                resolve(base64Image);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    } catch (error) {
        console.error("Error fetching or processing image:", error);
        throw error; // Re-throw the error for proper error handling in the calling code
    }
}

export const formatCountry = (country) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
            className={`fi fi-${country.iso_name} fi-rounded`}
            style={{
                marginRight: '8px',
                fontSize: '1.2em',
            }}
        ></span>
        {/* {convertToTitleCase(country.label)} */}
    </div>
);
// export const checkDateStatus = (date) => {
//     const today = moment().startOf("day"); // Get today's date at midnight
//     const inputDate = moment(date, "YYYY-MM-DD").startOf("day"); // Parse input date

//     return inputDate.isSameOrBefore(today) ? "Completed" : "Awaiting";
// };

export const checkDateStatus = (date, time) => {
    const now = moment(); // Get current datetime
    const inputDateTime = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm"); // Parse input date with time

    return inputDateTime.isSameOrBefore(now) ? "Completed" : "Awaiting";
};

const formatCountry2 = (country) => {
    // This function formats the country with an icon
    return `<i class="fi fi-${country.iso_name} fi-rounded"></i> ${convertToTitleCase(country.label)}`;
};

export const CountrySelectoptions = countries.map((country) => ({
    value: country.code,
    label: country.name,
    iso_name: country.iso_name,
}));

export const CountrySelectoptions2 = countries.map((country) => ({
    id: country.code,
    text: formatCountry2({ label: country.name, iso_name: country.iso_name }),
    value: country.code,
}));

export const ProviderSelectoptions2 = [
    // { id: 1, text: 'Bokun', value: 'Bokun' },
    // { id: 2, text: 'Fareharbor', value: 'Fareharbor' },
    // { id: 3, text: 'Pluralo', value: 'Pluralo' },
    // { id: 4, text: 'Turitop', value: 'Turitop' },
    { id: 5, text: 'Other', value: 'Other' },
    { id: 6, text: 'I don\'t have a tour booking provider', value: 'I don\'t have a tour booking provider' },
];

export const DefaultSelectedCountrySelectoption = CountrySelectoptions.filter((e) => e.label == 'PORTUGAL')

export const getCountryByCode = (code) => {
    if (code) {

        let countryIndex = countries.findIndex((e) => e.code == code)
        if (countryIndex != -1) {
            return countries[countryIndex]?.name ? convertToTitleCase(countries[countryIndex]?.name) : ''
        }

    }
    return "";

}

export function getLanguageName(code) {
    return Object.keys(Language).find(key => Language[key] === code) || null;
}

export function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}
export function getPaymentTypeText(type) {
    let method = ""
    if (type == "card") {
        method = "Stripe (Card)"
    }
    if (type == "mb_way") {
        method = "MB Way"
    }
    if (type == "cash") {
        method = "Cash"
    }

    if (type == "paypalint" || type == "paypal") {
        method = "Paypal"
    }
    if (type == "multibanco") {
        method = "Multibanco"
    }
    return method;

}

export function convert_ToSpace(input) {
    const formattedString = input.replace(/_/g, ' ');
    return formattedString;
}

export function getProductImageUrl(img) {
    // console.log('img',img);

    if (!img) return null;

    // Check if the image is already a full URL
    const isFullUrl = /^https?:\/\//i.test(img);

    if (isFullUrl) {
        return img;
    }

    // If only image name, construct the URL using helper values
    return `${helper.S3Url}/${helper.productImageDir}/${img}`;
}

export function getCookie(name) {
    let cookieArr = document.cookie.split("; ");
    for (let cookie of cookieArr) {
        let [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}


export default helper